import { ChangeDetectionStrategy, Component, effect, input, signal, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PayErrorResponse } from 'projects/login/src/app/services/auth/models/pay-error-response';

@Component({
  selector: 'pay-login-error-badge',
  imports: [TranslateModule],
  templateUrl: './error-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorBadgeComponent {
  readonly _translateService = inject(TranslateService);

  readonly error = input.required<PayErrorResponse | undefined>();
  readonly _error = signal<PayErrorResponse | undefined>(undefined);
  constructor() {
    const _translateService = this._translateService;

    effect(() => {
      this._error.set(this.error());
    });
    _translateService.onLangChange.subscribe({
      next: () => {
        this._error.set(undefined);
      },
    });
  }
}
